
import { motion } from "framer-motion";

const steps = [
  {
    n: "1",
    title: "Build",
    body:
      "We build a polished, mobile-first TapToTable Page customized for your restaurant, with promotions, events, featured menu items, photos, and your branding.",
  },
  {
    n: "2",
    title: "Review",
    body:
      "Review your completed page, experience it like a customer, and request any changes before activation.",
  },
  {
    n: "3",
    title: "Activate",
    body:
      "Activate your TapToTable Page for $59 per month only when you’re satisfied and ready to share it with customers.",
  },
  {
    n: "4",
    title: "Share",
    body:
      "Add your TapToTable link to Instagram and Facebook posts, your social bio, Google Business Profile, website, email, QR codes, and anywhere customers find your business.",
  },
  {
    n: "5",
    title: "Grow",
    body:
      "Customers discover your restaurant, claim promotions, explore featured menu items, respond to events, and take action. Update your page and monitor customer activity and supported analytics from your secure TapToTable Dashboard.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      className="py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-4"
          >
            <div className="label-caps">How it works</div>

            <h2 className="mt-3 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight">
              We Build It.
              <br />
              You Review It.
              <br />
              Then You Go Live.
            </h2>

            <p className="mt-5 text-zinc-400">
              We build your TapToTable Page, you review it and request changes,
              and you activate only when you&apos;re ready. Then share your link
              and use your secure TapToTable Dashboard to create and update
              Promotions, Events, and Featured Items, along with restaurant
              details, photos, links, customer actions, and more.
            </p>

            <p className="mt-4 text-sm leading-relaxed text-zinc-400">
              Run special offers with claim codes, promote upcoming events,
              or spotlight signature dishes without offering discounts.
              Choose the type of promotion that fits your restaurant.
            </p>
          </motion.div>

          <div className="lg:col-span-8 grid gap-4">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                className="group relative bg-[#121214] border border-white/5 rounded-2xl p-6 md:p-8 hover:border-[#00E5FF]/30 transition-all duration-300"
                data-testid={`how-step-${i}`}
              >
                <div className="flex items-start gap-6">
                  <div className="font-display font-semibold text-3xl md:text-4xl text-[#00E5FF]/80 group-hover:text-[#00E5FF] transition-colors">
                    {s.n}
                  </div>

                  <div className="flex-1">
                    <div className="font-display font-semibold text-lg md:text-xl">
                      {s.title}
                    </div>

                    <div className="mt-2 text-zinc-400 text-sm md:text-base max-w-xl">
                      {s.body}
                    </div>
                  </div>

                  <svg
                    className="opacity-0 group-hover:opacity-100 text-[#00E5FF] transition-opacity"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M5 12h14M13 5l7 7-7 7"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
